module.exports = __webpack_public_path__ + "img/ED2.9d4cba98.jpeg";